import { ChildEnrollmentAddEditForm } from 'components/templates';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { ChildEnrollmentFormFields } from 'types';
import { useNavigateWithState } from 'hooks/useNavigateWithState/useNavigateWithState';
import { appPaths } from 'consts/paths/paths';
import EnrollmentHTTPService from 'services/HTTPService/enrollment/EnrollmentHTTPService';
import { parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO } from 'utils/parsers/enrollment/parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO';
import { EnrollmentId } from 'types/enrollment/enrollment';
import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { enrollmentTexts } from 'consts/text';

export const EnrollmentEditPage = () => {
    const { statefulNavigate } = useNavigateWithState();

    const { displaySuccess } = useSimpleNotification();

    const onEditChildEnrollmentSuccess = () => {
        displaySuccess(enrollmentTexts.editForm.successMessage);
        statefulNavigate(appPaths.app.enrollment.base, { replace: true });
    };

    // TODO: to fetch child enrollment and pass to form as initial data

    const {
        mutate: editChildEnrollment,
        error: editChildEnrollmentError,
        isLoading: isEditChildEnrollmentLoading,
        // TODO: to change addChildEnrollment -> editChildEnrollment HTTP request
    } = useAppMutation(EnrollmentHTTPService.addChildEnrollment, {
        key: ['EDIT_CHILD_ENROLLMENT'],
        onSuccess: onEditChildEnrollmentSuccess,
        // TODO: to pass enrollmentId to invalidateQueryKeys
        invalidateQueryKeys: [['CHILD_ENROLLMENTS'], ['CHILD_ENROLLMENT']],
    });

    const onEditChildEnrollmentFinish = (childEnrollmentFormFields: ChildEnrollmentFormFields) => {
        const parsedEditChildEnrollmentDto =
            parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO(childEnrollmentFormFields);
        editChildEnrollment({
            // TODO: to pass enrollmentId to the backend
            enrollmentId: '' as EnrollmentId,
            createChildEnrollmentDTO: parsedEditChildEnrollmentDto,
        });
    };

    return (
        <ChildEnrollmentAddEditForm
            mode="edit"
            axiosError={editChildEnrollmentError}
            isLoading={isEditChildEnrollmentLoading}
            onFinish={onEditChildEnrollmentFinish}
        />
    );
};
